import {
  FieldArrayWithId,
  UseFieldArrayAppend,
  UseFieldArrayRemove,
  UseFormRegister,
} from 'react-hook-form';

import { PolicyDetailsSection, VehiclesSection } from './policy';
import { CoverageFormData } from './types';

interface PolicyDetailsTabProps {
  register: UseFormRegister<CoverageFormData>;
  policyDetailFields: FieldArrayWithId<
    CoverageFormData,
    'policy_details',
    'id'
  >[];
  appendPolicyDetail: UseFieldArrayAppend<CoverageFormData, 'policy_details'>;
  removePolicyDetail: UseFieldArrayRemove;
  vehicleFields: FieldArrayWithId<CoverageFormData, 'vehicles', 'id'>[];
  appendVehicle: UseFieldArrayAppend<CoverageFormData, 'vehicles'>;
  removeVehicle: UseFieldArrayRemove;
}

export const PolicyDetailsTab = ({
  register,
  policyDetailFields,
  appendPolicyDetail,
  removePolicyDetail,
  vehicleFields,
  appendVehicle,
  removeVehicle,
}: PolicyDetailsTabProps) => {
  return (
    <div className="space-y-6">
      <VehiclesSection
        register={register}
        vehicleFields={vehicleFields}
        appendVehicle={appendVehicle}
        removeVehicle={removeVehicle}
      />

      <PolicyDetailsSection
        register={register}
        policyDetailFields={policyDetailFields}
        appendPolicyDetail={appendPolicyDetail}
        removePolicyDetail={removePolicyDetail}
      />
    </div>
  );
};
